module.exports = __webpack_public_path__ + "static/media/Bullet.2156b72b.svg";